import React, { useState, useEffect } from 'react'
import { useTranslate } from 'react-polyglot'
import axios from 'axios'
import useAxios from 'axios-hooks'
import { toastr } from 'react-redux-toastr'

import EE from 'emitter.js'
import {
	Modal,
	Textarea,
	ButtonGroup,
	Button,
	FormFieldset,
	FormLabel,
	Text,
	Avatar,
	FlexContainer,
} from 'components'

import './suggestionModal.scss'

export default () => {
	const [isOpen, setIsOpen] = useState(false)
	const [text, setText] = useState('')
	const [admins, setAdmins] = useState([])

	const t = useTranslate()

	const [{}, sendSuggestion] = useAxios(
		{
			url: `teams/suggestion`,
			method: 'POST',
		},
		{
			manual: true,
		}
	)

	useEffect(() => {
		EE.on('showSuggestionModal', async () => {
			const { data } = await axios.get(`teams/members`)
			const a = data.filter(m => m.role === 300)

			setAdmins(a)
			setIsOpen(true)
		})

		return () => {
			EE.off('showSuggestionModal')
		}
	}, [])

	const onClose = () => {
		setIsOpen(false)
		setText('')
	}

	return (
		<Modal visible={isOpen} onClose={onClose} title={t('give_suggestion')}>
			<div className="c-suggestion-modal">
				<FormFieldset spacing="narrow">
					<FormLabel text={t('responsible_persons')} />
					<div className="c-suggestion-modal__recipients">
						{admins.map(u => (
							<div
								className="c-suggestion-modal__recipient"
								key={u.id}
							>
								<FlexContainer
									key={u.id}
									justifyContent="flex-start"
									smallSpacing
								>
									<Avatar
										initials={
											u.firstName.charAt(0) +
											u.lastName.charAt(0)
										}
										image={u.image}
									/>
									<Text color="dark" size="small">
										{`${u.firstName} ${u.lastName}`.trim()}
									</Text>
								</FlexContainer>
							</div>
						))}
					</div>
				</FormFieldset>
				<FormFieldset spacing="narrow">
					<Textarea
						label={t('your_suggestion_message')}
						placeholder={t('your_suggestion_message_placeholder')}
						value={text}
						onChange={e => {
							setText(e.target.value)
						}}
					/>
				</FormFieldset>
				<ButtonGroup orientation="horizontal">
					<Button
						onClick={async () => {
							try {
								await sendSuggestion({
									data: {
										recipients: admins.map(rm => rm.id),
										text,
									},
								})

								toastr.success('', t(`suggestion_sent`), {
									timeOut: 5000,
									removeOnHover: false,
									closeOnToastrClick: true,
								})

								onClose()
							} catch (error) {
								toastr.error(
									'',
									t(`errors.${error.response.data.message}`),
									{
										timeOut: 5000,
										removeOnHover: false,
										closeOnToastrClick: true,
									}
								)
							}
						}}
						text={t('send_suggestion')}
						size="small"
						layout="primary"
						disabled={!text.length}
					/>
					<Button onClick={onClose} text={t('cancel')} />
				</ButtonGroup>
			</div>
		</Modal>
	)
}
